import {scope, type} from 'arktype'

export const StyledText = type({
  'text?': 'string | null',
  'text_style?': 'string | null',
})

export const Price = type({
  'amount?': 'number | null',
  'currency?': 'string | null',
  'styled_text?': [StyledText, '|', 'null'],
})

export const TaxRate = type({
  'name?': 'string | null',
  'rate?': 'number | null',
  'included_in_item_price?': 'boolean | null',
})

export const QuantitySettings = type({
  'default_units?': 'number | null',
  'maximum_units?': 'number | null',
  'minimum_units?': 'number | null',
  'unit_increment?': 'number | null',
})

export const DisplaySettings = type({
  'display_type?': 'string | null',
})

export const PriceChanges = type({})

export const MiscellaneousTaxes = type({})

export const FlexibleTaxNumericFields = type({})

export const FlexibleTaxFields = type({})

export const AssetMedia = type({
  'base_url?': 'string | null',
  'public_id?': 'string | null',
  'format?': 'string | null',
  'tag?': 'string | null',
  'tags?': 'string[] | null',
  'image_source?': 'string | null',
  'uploader_details?': 'string | null',
  'image_description?': 'string | null',
  'image_title?': 'string | null',
  'scale_mode?': 'string | null',
})

export const types = scope({
  ChoiceCategoryList: {
    'id?': 'string | null',
    'name?': 'string | null',
    'min_choice_options?': 'number | null',
    'max_choice_options?': 'number | null',
    'choice_option_list?': 'ChoiceOptionList[]',
    'variation_target?': 'boolean | null',
    'sequence?': 'number | null',
    'quantity_settings?': [QuantitySettings, '|', 'null'],
    'display_settings?': [DisplaySettings, '|', 'null'],
  },
  ChoiceOptionList: {
    'id?': 'string | null',
    'description?': 'string | null',
    'label?': 'string | null',
    'price?': [Price, '|', 'null'],
    'delivery_price?': [Price, '|', 'null'],
    'pickup_price?': [Price, '|', 'null'],
    'miscellaneous_taxes?': [MiscellaneousTaxes.array(), '|', 'null'],
    'choice_category_list?': 'ChoiceCategoryList[]',
    'price_changes?': [Price, '|', 'null'],
    'sequence?': 'number | null',
    'defaulted?': 'boolean | null',
    'quantity_settings?': [QuantitySettings, '|', 'null'],
    'tags?': 'string[] | null',
    'asset_media?': [AssetMedia, '|', 'null'],
    'available?': 'boolean | null',
    'calorie_content?': 'string | null',
    'flexible_tax_fields?': [FlexibleTaxFields, '|', 'null'],
    'flexible_tax_numeric_fields?': [FlexibleTaxNumericFields, '|', 'null'],
  },
}).export()

export type ChoiceCategoryList = typeof types.ChoiceCategoryList.infer
export type ChoiceOptionList = typeof types.ChoiceOptionList.infer

export const RoutingTags = type({})

export const CategoryDetailProps = type({
  'id?': 'string | null',
  'restaurant_id?': 'number | null',
  'menu_category_name?': 'string | null',
  'menu_category_id?': 'string | null',
  'name?': 'string | null',
  'description?': 'string | null',
  'price?': [Price, '|', 'null'],
  'delivery_price?': [Price, '|', 'null'],
  'pickup_price?': [Price, '|', 'null'],
  'tax?': 'number | null',
  'tax_rate?': [TaxRate, '|', 'null'],
  'miscellaneous_taxes?': [MiscellaneousTaxes.array(), '|', 'null'],
  'minimum_cart_total?': [Price, '|', 'null'],
  'combinable_with_coupons?': 'boolean | null',
  'sequence?': 'number | null',
  'minimum_price_variation?': [Price, '|', 'null'],
  'delivery_minimum_price_variation?': [Price, '|', 'null'],
  'pickup_minimum_price_variation?': [Price, '|', 'null'],
  'maximum_price_variation?': [Price, '|', 'null'],
  'delivery_maximum_price_variation?': [Price, '|', 'null'],
  'pickup_maximum_price_variation?': [Price, '|', 'null'],
  'available?': 'boolean | null',
  'choice_category_list?': [types.ChoiceCategoryList.array(), '|', 'null'],
  'tag_list?': 'string[] | null',
  'media_image?': [AssetMedia, '|', 'null'],
  'media_images?': [AssetMedia.array(), '|', 'null'],
  'allowable_order_types?': 'string[] | null',
  'lead_time_ms?': 'number | null',
  'menu_item_features?': 'string[] | null',
  'in_store_only?': 'boolean | null',
  'gh_pos_only?': 'boolean | null',
  'calorie_content?': 'string | null',
  'routing_tags?': [RoutingTags.array(), '|', 'null'],
  'flexible_tax_fields?': [FlexibleTaxFields, '|', 'null'],
  'flexible_tax_numeric_fields?': [FlexibleTaxNumericFields, '|', 'null'],
  'item_coupon?': 'boolean | null',
  'popular?': 'boolean | null',
  'deleted?': 'boolean | null',
  'maximum_order_quantity?': 'number | null',
  'minimum_order_quantity?': 'number | null',
})

export type CategoryDetailProps = typeof CategoryDetailProps.infer
export const MenuItemDetails = CategoryDetailProps
export type MenuItemDetails = typeof MenuItemDetails.infer

export const CategoryDetailQueryProps = type({
  'restaurantId?': 'string | null',
  'categoryId?': 'string | null',
  'time?': 'number | null',
  'hideUnavailableMenuItems?': 'boolean | null',
  'orderType?': 'string | null',
  'locationMode?': 'string | null',
  'version?': 'number | null',
  'includeWeightedItemsData?': 'boolean | null',
  'location?': 'string | null',
})
export type CategoryDetailQueryProps = typeof CategoryDetailQueryProps.infer
